import Vue from 'vue'

export default {
  props: {
    showPopover: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popoverTimer: null,
      popoverInstance: null
    }
  },
  mounted() {
    this.$watch('newInputHovering', value => {
      if (value && !this.visible && this.showPopover) {
        this._createPopover()
      } else {
        this._removePopover()
      }
    })
    this.$watch('visible', value => {
      value && this._removePopover()
    })
  },
  beforeDestroy() {
    this._removePopover()
  },
  methods: {
    _popperMouseEnter() {
      this._showPopover()
    },
    _popperMouseLeave() {
      this._removePopover()
    },
    _createPopover() {
      this.$nextTick(() => {
        const selectEl = this.$el
        if (!(selectEl && Array.isArray(this.selected) && this.selected.length > 0)) {
          return
        }

        if (this.popoverInstance) {
          return
        }

        const PopoverComponent = Vue.extend({
          render: h => {
            return (
              <el-popover
                ref="popover"
                placement="bottom-start"
                trigger="manual"
                disabled={this.selected.length === 0}
                popper-class="el-select__popover">
                <div class="el-select__popover-content">
                  {this.selected.map((item, idx) => (
                    <div key={idx} class="el-select__popover-item">
                      {item.label}
                    </div>
                  ))}
                </div>
              </el-popover>
            )
          }
        })

        const popoverInstance = new PopoverComponent().$mount()
        document.body.appendChild(popoverInstance.$el)

        const popover = popoverInstance.$refs.popover

        // 绑定目标元素
        popover.referenceElm = selectEl

        this.popoverInstance = popoverInstance

        this._bindPopperEvent()

        this._showPopover()
      })
    },
    _bindPopperEvent () {
      const popover = this.popoverInstance && this.popoverInstance.$refs.popover
      if (popover && popover.$refs.popper) {
        popover.$refs.popper.addEventListener('mouseenter', this._popperMouseEnter)
        popover.$refs.popper.addEventListener('mouseleave', this._popperMouseLeave)
      }
    },
    _unbindPopperEvent () {
      const popover = this.popoverInstance && this.popoverInstance.$refs.popover
      if (popover && popover.$refs.popper) {
        popover.$refs.popper.removeEventListener('mouseenter', this._popperMouseEnter)
        popover.$refs.popper.removeEventListener('mouseleave', this._popperMouseLeave)
      }
    },
    // 延迟显示，避免频繁显示/隐藏
    _showPopover () {
      clearTimeout(this.popoverTimer)
      this.popoverTimer = setTimeout(() => {
        const popover = this.popoverInstance && this.popoverInstance.$refs.popover
        if (popover) {
          popover.showPopper = true
        }
      }, 200)
    },
    _removePopover () {
      clearTimeout(this.popoverTimer)
      // 延迟关闭，鼠标引入气泡中需要滚动
      this.popoverTimer = setTimeout(() => {
        if (this.popoverInstance) {
          document.body.removeChild(this.popoverInstance.$el)
          this.popoverInstance.$destroy()
        }
        this._unbindPopperEvent()
        this.popoverInstance = null
      }, 200)
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-select/mixins/popover.js